import React from 'react';
import { EdgeLabelRenderer } from 'reactflow';

const CustomEdge = ({ id, data, style, markerEnd }) => {
  return (
    <>
      {data?.path && (
        <>
          {/* Invisible buffer for easier hovering */}
          <path
            d={data.path}
            style={{
              fill: 'none',
              stroke: 'transparent',
              strokeWidth: 20,
              pointerEvents: 'stroke',
              cursor: 'pointer',
            }}
          />
          {/* Visible edge path */}
          <path
            d={data.path}
            style={{
              fill: 'none',
              stroke: style?.stroke || data.color,
              strokeWidth: style?.strokeWidth || 2,
              opacity: style?.opacity !== undefined ? style.opacity : 1,
              transition: style?.transition,
              pointerEvents: 'none',
            }}
            markerEnd={markerEnd}
          />
        </>
      )}

      {data?.labelX !== undefined && data?.labelY !== undefined && data?.label && (
        <EdgeLabelRenderer>
          <div
            style={{
              position: 'absolute',
              left: data.labelX,
              top: data.labelY,
              transform: 'translate(-50%, -50%)',
              pointerEvents: 'all',
              fontSize: 11,
              fontWeight: 600,
              fontFamily: "'Open Sans', sans-serif",
              opacity: style?.opacity !== undefined ? style.opacity : 1,
              transition: style?.transition,
            }}
          >
            <div
              style={{
                background: '#ffffff',
                border: `1.5px solid ${style?.stroke || data.color}`,
                borderRadius: 11,
                padding: '4px 8px',
                whiteSpace: 'nowrap',
                color: style?.stroke || data.color,
                fontWeight: 600,
              }}
            >
              {data.label}
            </div>
          </div>
        </EdgeLabelRenderer>
      )}
    </>
  );
};

export default CustomEdge;



